import o from "./index59.mjs";
import i from "./index61.mjs";
function f(t) {
  var r = i(t, "string");
  return o(r) == "symbol" ? r : r + "";
}
export {
  f as default
};
